import React from "react";
import Heading from "@druva-apps/orion/lib/heading";
import Button from "@druva-apps/orion/lib/button";

import BackButton from "../BackButton";
import FormCardBody from "../FormCardBody";

/**
 * Post–forgot-password success (WF-8C): matches login-experience/15.forgot-password-link-sent-screen.
 */
const ForgotPasswordLinkSent = ({ onResend, onGoToLogin, isResending }) => {
  return (
    <FormCardBody
      footer={
        <BackButton
          dataTestId="forgot-pw-sent-go-login-btn"
          onClick={onGoToLogin}
          label="Go to Login"
        />
      }
    >
      <Heading
        type="4"
        text="Verification Link Sent"
        className="oui-font-weight-bold oui-mt-2 oui-mb-4 oui-text-center"
        dataTestId="forgot-pw-sent-heading"
      />
      <div className="oui-mb-3 oui-text-left oui-ml-2 oui-mr-2">
        <p className="oui-mb-2">
          We have sent a verification link to your registered email address.
          Click on the link to reset your password.
        </p>
        <Button
          type="link"
          label="Resend Email"
          onClick={onResend}
          disabled={isResending}
          dataTestId="forgot-pw-sent-resend-btn"
          size="sm"
          className="oui-text-decoration-none oui-p-0"
        />
      </div>
    </FormCardBody>
  );
};

export default ForgotPasswordLinkSent;
